module.exports = __webpack_public_path__ + "static/media/default-img.6ae6aba6.png";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/default-img.png
// module id = ./src/theme/images/default-img.png
// module chunks = 1